module.exports = __webpack_public_path__ + "img/getway.4d191021.png";